import { DEFAULT_FSK_BANNER } from 'node/map-search/mappers/fskContent/fskContent';

import { IFskBanner } from '../../types/fskContent/fskContent';

const defaultState: IFskBanner = DEFAULT_FSK_BANNER;

export function fskBannerReducer(state: IFskBanner = defaultState): IFskBanner {
  return state;
}
